<template>
  <div
    style="background-color: #e4e4e7"
    class="flex justify-center items-center fixed w-full h-full bg-white top-0 left-0 z-50"
  >
    <div class="w-[400px]">
      <div class="mb-5 flex justify-center items-center">
        <img src="@/assets/logo.svg" class="h-14" />
      </div>
      <el-form
        class="px-7 py-5 pb-3 rounded-md"
        label-position="top"
        style="background-color: #fff"
      >
        <el-form-item label="Email">
          <el-input v-model="email"></el-input>
        </el-form-item>
        <el-form-item label="Пароль">
          <el-input
            @keydown.enter="login"
            show-password
            type="password"
            v-model="password"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="loading"
            @click="login"
            type="primary"
            plain
            class="w-full"
            >Войти</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ElForm, ElFormItem, ElInput, ElButton, ElMessage } from "element-plus";
import apiClient from "@/api/apiClient";

export default {
  name: "AuthView",
  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
  },
  data: () => ({
    email: null,
    password: null,
    loading: false,
  }),
  methods: {
    async login() {
      this.loading = true;
      try {
        const res = await apiClient.post("login", {
          email: this.email,
          password: this.password,
        });

        const { accessToken } = res.data;
        localStorage.setItem("access_token", accessToken);

        this.$router.push({ name: "home" });
        setTimeout(() => {
          window.location.reload();
        }, 200);
      } catch (e) {
        ElMessage.error(e.message);
        console.log(e.message);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
